function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _array_without_holes(arr) {
    if (Array.isArray(arr)) return _array_like_to_array(arr);
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterable_to_array(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _non_iterable_spread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _to_consumable_array(arr) {
    return _array_without_holes(arr) || _iterable_to_array(arr) || _unsupported_iterable_to_array(arr) || _non_iterable_spread();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
function _ts_generator(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React from 'react';
import { getDefaultCommands, updateDefaultCommand } from '@/actions/CommandActions';
import Table from '@/components/Table';
import { ActionIcon, Badge, Table as MantineTable, Menu, Switch, Text } from '@mantine/core';
import UserLevelTag from '@/components/UserLevelTag';
import { faBook, faEllipsisV, faMagicWandSparkles, faPencil } from '@fortawesome/free-solid-svg-icons';
import TableHeading from '@/components/TableHeading';
import { getUserLevelValue } from '@/utils/userlevel';
import { CommandsLayoutContext } from '@/components/layouts/CommandsLayout';
import useDefaultCommandStore from '@/stores/DefaultCommandStore';
import useChannelStore from '@/stores/ChannelStore';
import { useLimitQueryState, usePageQueryState, useSortDirectionQueryState } from '@/hooks/usePaginationQueryState';
import { SortDirections } from '@/types/client';
import EmptyState from '@/components/EmptyState';
import useQueryState from '@/hooks/useQueryState';
import { FormattedMessage, useIntl } from 'react-intl';
import Pagination from '../Pagination';
import { useShallow } from 'zustand/react/shallow';
import { useDebounce } from 'use-debounce';
import { useNavigate } from 'react-router';
import { DynamicWebRoutes } from '@/utils/constants';
import Icon, { IconSizes } from '../Icon';
import styles from './CommandsDefault.module.scss';
import TargetDropdown from '../TargetDropdown';
var HeadingKeys;
(function(HeadingKeys) {
    HeadingKeys["ENABLED"] = "enabled";
    HeadingKeys["COMMAND"] = "command";
    HeadingKeys["DESCRIPTION"] = "description";
    HeadingKeys["USER_LEVEL"] = "userLevel";
})(HeadingKeys || (HeadingKeys = {}));
var _obj;
var SortFunctions = (_obj = {}, _define_property(_obj, "enabled", function(a, b) {
    return Number(a.enabled) - Number(b.enabled);
}), _define_property(_obj, "command", function(a, b) {
    return a.name.localeCompare(b.name);
}), _define_property(_obj, "description", function(a, b) {
    return a._description.localeCompare(b._description);
}), _define_property(_obj, "userLevel", function(a, b) {
    return getUserLevelValue(a.userLevel) - getUserLevelValue(b.userLevel);
}), _obj);
function DefaultCommandHeader(param) {
    var sortBy = param.sortBy, sortDirection = param.sortDirection, setSortDirection = param.setSortDirection, setSortBy = param.setSortBy;
    function handleSortChange(key, direction) {
        setSortDirection(direction);
        setSortBy(direction != null ? key : null);
    }
    return /*#__PURE__*/ _jsxs(MantineTable.Tr, {
        children: [
            /*#__PURE__*/ _jsx(TableHeading, {
                visibleFrom: "sm",
                active: sortBy === "enabled",
                sort: sortDirection,
                setSort: function(direction) {
                    return handleSortChange("enabled", direction);
                },
                children: /*#__PURE__*/ _jsx(FormattedMessage, {
                    id: "V52jNn",
                    defaultMessage: "Enabled"
                })
            }),
            /*#__PURE__*/ _jsx(TableHeading, {
                active: sortBy === "command",
                sort: sortDirection,
                setSort: function(direction) {
                    return handleSortChange("command", direction);
                },
                children: /*#__PURE__*/ _jsx(FormattedMessage, {
                    id: "9WyylR",
                    defaultMessage: "Command"
                })
            }),
            /*#__PURE__*/ _jsx(TableHeading, {
                visibleFrom: "sm",
                active: sortBy === "description",
                sort: sortDirection,
                setSort: function(direction) {
                    return handleSortChange("description", direction);
                },
                children: /*#__PURE__*/ _jsx(FormattedMessage, {
                    id: "Q8Qw5B",
                    defaultMessage: "Description"
                })
            }),
            /*#__PURE__*/ _jsx(TableHeading, {
                visibleFrom: "sm",
                alignRight: true,
                active: sortBy === "userLevel",
                sort: sortDirection,
                setSort: function(direction) {
                    return handleSortChange("userLevel", direction);
                },
                children: /*#__PURE__*/ _jsx(FormattedMessage, {
                    id: "hqByQG",
                    defaultMessage: "User-Level"
                })
            }),
            /*#__PURE__*/ _jsx(TableHeading, {
                alignRight: true,
                visibleFrom: "sm",
                children: /*#__PURE__*/ _jsx(FormattedMessage, {
                    id: "wL7VAE",
                    defaultMessage: "Actions"
                })
            })
        ]
    });
}
var MemoizedDefaultCommandHeader = /*#__PURE__*/ React.memo(DefaultCommandHeader);
function DefaultCommandRow(param) {
    var command = param.command, onEdit = param.onEdit, onEnabled = param.onEnabled, setMenuData = param.setMenuData;
    var intl = useIntl();
    var ref = React.useRef(null);
    var _React_useState = _sliced_to_array(React.useState(false), 2), loading = _React_useState[0], setLoading = _React_useState[1];
    var handleToggleEnabled = React.useCallback(function() {
        setLoading(true);
        onEnabled(command).finally(function() {
            return setLoading(false);
        });
    }, [
        command,
        onEnabled
    ]);
    return /*#__PURE__*/ _jsxs(MantineTable.Tr, {
        children: [
            /*#__PURE__*/ _jsx(MantineTable.Td, {
                visibleFrom: "sm",
                className: styles.commandEnabledColumn,
                children: /*#__PURE__*/ _jsx("div", {
                    className: styles.commandEnabledSwitchContainer,
                    children: /*#__PURE__*/ _jsx(Switch, {
                        color: "blue",
                        disabled: loading,
                        checked: command.enabled,
                        onChange: handleToggleEnabled
                    })
                })
            }),
            /*#__PURE__*/ _jsxs(MantineTable.Td, {
                className: styles.commandNameColumn,
                children: [
                    /*#__PURE__*/ _jsxs("div", {
                        className: styles.commandNameStack,
                        children: [
                            /*#__PURE__*/ _jsx(Text, {
                                className: styles.commandName,
                                children: command.name
                            }),
                            /*#__PURE__*/ _jsx(Badge, {
                                className: styles.commandEnabledBadge,
                                radius: "sm",
                                variant: "inverse",
                                hiddenFrom: "sm",
                                children: command.enabled ? /*#__PURE__*/ _jsx(FormattedMessage, {
                                    id: "V52jNn",
                                    defaultMessage: "Enabled"
                                }) : /*#__PURE__*/ _jsx(FormattedMessage, {
                                    id: "tthToS",
                                    defaultMessage: "Disabled"
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsx(Text, {
                        size: "sm",
                        className: styles.commandDescription,
                        hiddenFrom: "sm",
                        children: command._description
                    })
                ]
            }),
            /*#__PURE__*/ _jsx(MantineTable.Td, {
                visibleFrom: "sm",
                className: styles.commandMessageColumn,
                children: command._description
            }),
            /*#__PURE__*/ _jsx(MantineTable.Td, {
                visibleFrom: "sm",
                className: styles.commandUserLevelColumn,
                children: /*#__PURE__*/ _jsx(UserLevelTag, {
                    showIcon: false,
                    userLevel: command.userLevel
                })
            }),
            /*#__PURE__*/ _jsx(MantineTable.Td, {
                className: styles.commandActionsColumn,
                children: /*#__PURE__*/ _jsxs("div", {
                    className: styles.actionIcons,
                    children: [
                        /*#__PURE__*/ _jsx(ActionIcon, {
                            size: "xs",
                            visibleFrom: "sm",
                            "aria-label": intl.formatMessage({
                                id: "dGRQmn",
                                defaultMessage: [
                                    {
                                        type: 0,
                                        value: "Edit Command"
                                    }
                                ]
                            }),
                            onClick: function() {
                                return onEdit(command);
                            },
                            children: /*#__PURE__*/ _jsx(Icon, {
                                size: IconSizes.SM,
                                icon: faPencil
                            })
                        }),
                        /*#__PURE__*/ _jsx(ActionIcon, {
                            size: "xs",
                            visibleFrom: "sm",
                            "aria-label": intl.formatMessage({
                                id: "7y9FPY",
                                defaultMessage: [
                                    {
                                        type: 0,
                                        value: "Open Documentation"
                                    }
                                ]
                            }),
                            onClick: function() {
                                return window.open(command._docs, '_blank');
                            },
                            children: /*#__PURE__*/ _jsx(Icon, {
                                size: IconSizes.SM,
                                icon: faBook
                            })
                        }),
                        /*#__PURE__*/ _jsx(ActionIcon, {
                            size: "md",
                            hiddenFrom: "sm",
                            "aria-label": intl.formatMessage({
                                id: "dGRQmn",
                                defaultMessage: [
                                    {
                                        type: 0,
                                        value: "Edit Command"
                                    }
                                ]
                            }),
                            onClick: function() {
                                return setMenuData({
                                    command: command,
                                    targetRef: ref
                                });
                            },
                            ref: ref,
                            children: /*#__PURE__*/ _jsx(Icon, {
                                size: IconSizes.MD,
                                icon: faEllipsisV
                            })
                        })
                    ]
                })
            })
        ]
    });
}
var MemoizedDefaultCommandRow = /*#__PURE__*/ React.memo(DefaultCommandRow);
function CommandsDefault() {
    var channel = useChannelStore(function(state) {
        return state.channel;
    });
    var intl = useIntl();
    var navigate = useNavigate();
    var _React_useState = _sliced_to_array(React.useState(null), 2), menuData = _React_useState[0], setMenuData = _React_useState[1];
    var _useDefaultCommandStore = useDefaultCommandStore(useShallow(function(state) {
        return {
            isLoading: state.isLoading,
            commands: channel != null ? state.getCommandsForChannel(channel._id) : null
        };
    })), commands = _useDefaultCommandStore.commands, isLoading = _useDefaultCommandStore.isLoading;
    var search = React.useContext(CommandsLayoutContext);
    var _useDebounce = _sliced_to_array(useDebounce(search, 500), 1), debouncedSearch = _useDebounce[0];
    var _useSortDirectionQueryState = _sliced_to_array(useSortDirectionQueryState(), 2), sortDirection = _useSortDirectionQueryState[0], setSortDirection = _useSortDirectionQueryState[1];
    var _useQueryState = _sliced_to_array(useQueryState('sortBy', {
        defaultValue: "command"
    }), 2), sortBy = _useQueryState[0], setSortBy = _useQueryState[1];
    var _usePageQueryState = _sliced_to_array(usePageQueryState(), 2), page = _usePageQueryState[0], setPage = _usePageQueryState[1];
    var _useLimitQueryState = _sliced_to_array(useLimitQueryState(), 2), limit = _useLimitQueryState[0], setLimit = _useLimitQueryState[1];
    React.useEffect(function() {
        if (isLoading || channel == null) {
            return;
        }
        getDefaultCommands(channel._id);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        channel
    ]);
    var sortedCommands = React.useMemo(function() {
        var sortedCommands = commands;
        if (sortedCommands == null) {
            return null;
        }
        if (debouncedSearch.length > 0) {
            var normalizedQuery = debouncedSearch.toLowerCase();
            sortedCommands = sortedCommands.filter(function(command) {
                return command.name.toLowerCase().includes(normalizedQuery) || command._description.toLowerCase().includes(normalizedQuery);
            });
        }
        var sortFn = sortBy != null ? SortFunctions[sortBy] : null;
        if (sortFn == null) {
            return sortedCommands;
        }
        sortedCommands = _to_consumable_array(sortedCommands);
        return sortDirection === SortDirections.ASC ? sortedCommands.sort(sortFn) : sortedCommands.sort(function(a, b) {
            return -sortFn(a, b);
        });
    }, [
        commands,
        debouncedSearch,
        sortDirection,
        sortBy
    ]);
    var handleEdit = React.useCallback(function(command) {
        return navigate(DynamicWebRoutes.COMMANDS_DEFAULT_EDIT(command._name));
    }, [
        navigate
    ]);
    var slicedCommands = React.useMemo(function() {
        if (sortedCommands == null) {
            return null;
        }
        return sortedCommands.slice(page * limit, (page + 1) * limit);
    }, [
        sortedCommands,
        page,
        limit
    ]);
    var handleEnabled = React.useCallback(/*#__PURE__*/ function() {
        var _ref = _async_to_generator(function(command) {
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (channel == null) {
                            return [
                                2
                            ];
                        }
                        return [
                            4,
                            updateDefaultCommand(channel._id, {
                                _name: command._name,
                                enabled: !command.enabled
                            })
                        ];
                    case 1:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        });
        return function(command) {
            return _ref.apply(this, arguments);
        };
    }(), [
        channel
    ]);
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx(Table, {
                data: slicedCommands,
                extraData: [
                    handleEdit,
                    sortBy,
                    sortDirection,
                    limit,
                    page,
                    setMenuData
                ],
                keyExtractor: function(command) {
                    return command._name;
                },
                renderHeader: function() {
                    return /*#__PURE__*/ _jsx(MemoizedDefaultCommandHeader, {
                        sortBy: sortBy,
                        sortDirection: sortDirection,
                        setSortDirection: setSortDirection,
                        setSortBy: setSortBy
                    });
                },
                renderEmptyState: function() {
                    return /*#__PURE__*/ _jsx(EmptyState, {
                        title: intl.formatMessage({
                            id: "4g7J7x",
                            defaultMessage: [
                                {
                                    type: 0,
                                    value: "No Default Commands Found"
                                }
                            ]
                        }),
                        description: intl.formatMessage({
                            id: "2uW69H",
                            defaultMessage: [
                                {
                                    type: 0,
                                    value: "Default commands are commands that are built into Nightbot and cannot be removed."
                                }
                            ]
                        }),
                        icon: /*#__PURE__*/ _jsx(Icon, {
                            size: IconSizes.LG,
                            icon: faMagicWandSparkles
                        })
                    });
                },
                renderRow: function(command) {
                    return /*#__PURE__*/ _jsx(MemoizedDefaultCommandRow, {
                        command: command,
                        onEdit: handleEdit,
                        setMenuData: setMenuData,
                        onEnabled: handleEnabled
                    });
                },
                renderFooter: function() {
                    var _sortedCommands_length;
                    return /*#__PURE__*/ _jsx(Pagination, {
                        limit: limit,
                        page: page,
                        setLimit: setLimit,
                        total: (_sortedCommands_length = sortedCommands === null || sortedCommands === void 0 ? void 0 : sortedCommands.length) !== null && _sortedCommands_length !== void 0 ? _sortedCommands_length : 0,
                        nextPage: function() {
                            return setPage(page + 1);
                        },
                        previousPage: function() {
                            return setPage(page - 1);
                        }
                    });
                }
            }),
            /*#__PURE__*/ _jsxs(TargetDropdown, {
                position: "bottom-end",
                targetRef: menuData === null || menuData === void 0 ? void 0 : menuData.targetRef,
                opened: menuData != null,
                dropdownProps: {
                    hiddenFrom: 'sm'
                },
                onClose: function() {
                    return setMenuData(null);
                },
                children: [
                    /*#__PURE__*/ _jsx(Menu.Label, {
                        children: /*#__PURE__*/ _jsx(FormattedMessage, {
                            id: "wL7VAE",
                            defaultMessage: "Actions"
                        })
                    }),
                    /*#__PURE__*/ _jsxs(React.Fragment, {
                        children: [
                            /*#__PURE__*/ _jsx(Menu.Item, {
                                onClick: function() {
                                    return handleEnabled(menuData.command);
                                },
                                children: /*#__PURE__*/ _jsx(FormattedMessage, {
                                    id: "D5bi7T",
                                    defaultMessage: "Toggle Command"
                                })
                            }),
                            /*#__PURE__*/ _jsx(Menu.Item, {
                                onClick: function() {
                                    return handleEdit(menuData.command);
                                },
                                children: /*#__PURE__*/ _jsx(FormattedMessage, {
                                    id: "dGRQmn",
                                    defaultMessage: "Edit Command"
                                })
                            }),
                            /*#__PURE__*/ _jsx(Menu.Item, {
                                onClick: function() {
                                    return window.open(menuData.command._docs, '_blank');
                                },
                                children: /*#__PURE__*/ _jsx(FormattedMessage, {
                                    id: "7y9FPY",
                                    defaultMessage: "Open Documentation"
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
}
export default CommandsDefault;
